import { AccentColor } from 'helpers/AccentColorHelper';

export const buttonColors = { borderColor: AccentColor(), color: AccentColor() };
export const primaryButtonColors = { background: AccentColor(), borderColor: AccentColor() };
